import React, { useEffect, useState } from "react";
import { useGetFetch } from "../../data/Queries";
import { dietPackageGet, dietPackageGetKey } from "../../data/ApiEndpoints";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { selectToken } from "../../components/auth/auth.selector";
import Loader from "../../components/ui/Loader";
import { Container, Row, Col } from "react-bootstrap";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
import "../../styles/diet/diet.css";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import DPfilters from "../../components/diet/dietPackage/DPfilters";
import { formattedLongDate } from "../../components/common-data/Converts";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import DPForm from "../../components/diet/dietPackage/DPForm";
import { showConfirmAlert } from "../../components/components-react/ReactAlert";
import { deleteDietPackage } from "../../redux/reducers/deleteApiSlice";
import ViewGoalDiets from "../../components/diet/dietPackage/ViewGoalDiets";
import HelmetWrapper from "../../HelmetWrapper";

const DietPackage = () => {
  const token = useSelector(selectToken);
  const dispatch = useDispatch();

  const iniModalValues = {
    editModal: false,
    editData: {},
  };
  const [isModalOpen, setIsModalOpen] = useState(iniModalValues);

  const [isPage, setIsPage] = useState(0);

  const initialDPFilters = {
    searchString: "",
    isActive: "",
    selectedBodyType: "",
    selectedDietPreference: "",
  };
  const [dpFilters, setDPFilters] = useState(initialDPFilters);
  const [sendableQPs, setSendableQPs] = useState("");
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const initialClickValues = {
    name: "",
    editModal: false,
    detailsModal: false,
    dpDetails: [],
    rowData: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);

  const {
    data: dietPackages,
    isLoading: isLoadingDietPackages,
    isFetching: isFetchingDietPackages,
    refetch: refetchDietPackages,
  } = useGetFetch({
    token,
    isPage: isPage + 1,
    filters: sendableQPs,
    url: dietPackageGet,
    key: dietPackageGetKey,
  });

  function isData() {
    try {
      if (isLoadingDietPackages || isFetchingDietPackages) {
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
    }
  }

  const onClickSearch = () => {
    setSearchFilterApplied(true);

    setSendableQPs((prevQP) => ({
      ...prevQP,
      search: dpFilters.searchString,
    }));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };

  const onClickValues = (e, rowData, name) => {
    e.preventDefault();

    setIsModalOpen({
      ...isModalOpen,
      editData: rowData,
      editModal: name === "edit" ? true : false,
    });
  };

  const onClose = () => {
    setIsModalOpen(iniModalValues);
  };

  const handleDelete = async (e, uid) => {
    e.preventDefault();

    const handleConfirm = async () => {
      if (uid) {
        try {
          const response = await dispatch(
            deleteDietPackage({
              TOKEN: token,
              UID: uid,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(
              response?.message || "Diet Package is deleted successfully!"
            );
            try {
              refetchDietPackages();
            } catch (error) {
              console.log(error);
            }
          } else {
            toast.error(response?.message || "Can not delete Diet Package!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete Diet Package");
        }
      } else {
        toast.error("UID required!");
      }
    };

    showConfirmAlert(handleConfirm, `Are you sure, you want to delete this!`);
  };

  useEffect(() => {
    setSendableQPs((prevQP) => ({
      ...prevQP,
      status: dpFilters.isActive?.value || "",
      type1: dpFilters.selectedBodyType?.value || "",
      type2: dpFilters.selectedDietPreference?.value || "",
    }));
  }, [dpFilters.isActive, dpFilters.selectedBodyType, dpFilters.selectedDietPreference]);

  useEffect(() => {
    if (dpFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setSendableQPs((prevQPs) => {
        const updatedQPs = { ...prevQPs };
        delete updatedQPs.search;
        return updatedQPs;
      });
    }
  }, [dpFilters.searchString]);

  useEffect(() => {
    try {
      refetchDietPackages();
    } catch (error) {
      console.log(error);
    }
  }, [isPage, sendableQPs]);

  const dietPackageCols = [
    {
      dataField: "name",
      text: "name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.name || "NA"}
            <br />
            <small>({row?.diet_cat_type || "NA"})</small>
          </span>
        );
      },
    },
    {
      dataField: "min_cal",
      text: "Calorie range",
      formatter: (cell, row) => (
        <div className="multi-tb-data-range minWidth90">
          <span className="tb-data">{row?.min_cal || "0"}</span> -{" "}
          <span className="tb-data">{row?.max_cal || "0"}</span>
        </div>
      ),
    },
    // {
    //   dataField: "diet_cat_type",
    //   text: "Diet Category",
    //   formatter: (cell, row) => {
    //     return <span className="tb-data">{row?.diet_cat_type || "NA"}</span>;
    //   },
    // },
    {
      dataField: "type1_name",
      text: "Diet Type",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.type1_name || "NA"}</span>;
      },
    },
    {
      dataField: "type2_name",
      text: "Body Preference",
      formatter: (cell, row) => {
        return <span className="tb-data minWidth150">{row?.type2_name || "NA"}</span>;
      },
    },
    {
      dataField: "duration",
      text: "duration",
      formatter: (cell, row) => {
        return <span className="tb-data minWidth90">{row?.duration || "0"} Day(S)</span>;
      },
    },
    {
      dataField: "estimated_weight_loss",
      text: "estimated weight loss/gain (KG)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.estimated_weight_loss || 0}
          </span>
        );
      },
    },
    // {
    //   dataField: "is_paid",
    //   text: "Free/Paid",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data">
    //         {row?.is_paid === 1 ? "Paid" : row?.is_paid === 0 ? "Free" : "NA"}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "user_name",
    //   text: "user name",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data">
    //         {row?.diet_cat_type === "custom" ? row?.user_name : "NA"}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth90">
            {row?.date_added ? formattedLongDate(+row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon view"
            onClick={(e) =>
              setClickValues((prevs) => ({
                ...prevs,
                detailsModal: true,
                mealDetails: row?.goal_diet,
                rowData: row,
              }))
            }
            style={{
              border:
                row?.goal_diet?.length > 0
                  ? "1px solid #bc0909"
                  : "1px solid #9C9C9C",
              color: row?.goal_diet?.length > 0 ? "#bc0909" : "#9C9C9C",
              borderRadius: "12px",
              cursor: row?.goal_diet?.length > 0 ? "pointer" : "not-allowed",
            }}
            disabled={row?.goal_diet?.length === 0}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrows-angle-expand"
              viewBox="0 0 16 16"
              style={{
                color: row?.goal_diet?.length > 0 ? "#bc0909" : "#9C9C9C",
              }}
            >
              <path
                fillRule="evenodd"
                d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
              />
            </svg>
          </button>
          <button
            className="actionBtn icon edit"
            onClick={(e) => onClickValues(e, row, "edit")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M3.62891 17.3603V20.3254C3.62891 20.5985 3.84349 20.8131 4.1166 20.8131H7.08175C7.20855 20.8131 7.33535 20.7643 7.42313 20.6668L18.0743 10.0254L14.4166 6.36775L3.77521 17.0091C3.67768 17.1067 3.62891 17.2237 3.62891 17.3603ZM20.9029 7.19682C20.9933 7.10658 21.065 6.9994 21.114 6.88141C21.1629 6.76341 21.1881 6.63692 21.1881 6.50918C21.1881 6.38143 21.1629 6.25495 21.114 6.13695C21.065 6.01896 20.9933 5.91177 20.9029 5.82154L18.6205 3.53915C18.5302 3.44873 18.4231 3.37699 18.3051 3.32805C18.1871 3.2791 18.0606 3.25391 17.9328 3.25391C17.8051 3.25391 17.6786 3.2791 17.5606 3.32805C17.4426 3.37699 17.3354 3.44873 17.2452 3.53915L15.4603 5.32409L19.1179 8.98176L20.9029 7.19682Z"
                fill="url(#paint0_linear_14023_4477)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_14023_4477"
                  x1="3.62891"
                  y1="11.6344"
                  x2="21.1881"
                  y2="11.6344"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.0447915" stopColor="#B4000B" />
                  <stop offset="1" stopColor="#DD0000" />
                </linearGradient>
              </defs>
            </svg>
          </button>
          <button
            className="actionBtn icon delete"
            onClick={(e) => handleDelete(e, row?.uid)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M8.49846 4.3041H11.4978C11.4978 3.90637 11.3398 3.52492 11.0585 3.24369C10.7773 2.96245 10.3958 2.80445 9.99811 2.80445C9.60038 2.80445 9.21893 2.96245 8.9377 3.24369C8.65646 3.52492 8.49846 3.90637 8.49846 4.3041ZM7.4987 4.3041C7.4987 3.64121 7.76203 3.00548 8.23076 2.53675C8.69949 2.06802 9.33522 1.80469 9.99811 1.80469C10.661 1.80469 11.2967 2.06802 11.7655 2.53675C12.2342 3.00548 12.4975 3.64121 12.4975 4.3041H17.4963C17.6289 4.3041 17.7561 4.35676 17.8498 4.45051C17.9435 4.54425 17.9962 4.6714 17.9962 4.80398C17.9962 4.93655 17.9435 5.0637 17.8498 5.15745C17.7561 5.25119 17.6289 5.30386 17.4963 5.30386H16.4426L15.2489 15.6454C15.1645 16.3764 14.8143 17.0509 14.265 17.5405C13.7156 18.0302 13.0054 18.3007 12.2696 18.3008H7.72664C6.99077 18.3007 6.2806 18.0302 5.73125 17.5405C5.18191 17.0509 4.83173 16.3764 4.74735 15.6454L3.55363 5.30386H2.49988C2.3673 5.30386 2.24016 5.25119 2.14641 5.15745C2.05267 5.0637 2 4.93655 2 4.80398C2 4.6714 2.05267 4.54425 2.14641 4.45051C2.24016 4.35676 2.3673 4.3041 2.49988 4.3041H7.4987ZM8.99834 8.30315C8.99834 8.17057 8.94568 8.04343 8.85193 7.94968C8.75819 7.85593 8.63104 7.80327 8.49846 7.80327C8.36588 7.80327 8.23874 7.85593 8.14499 7.94968C8.05125 8.04343 7.99858 8.17057 7.99858 8.30315V14.3017C7.99858 14.4343 8.05125 14.5615 8.14499 14.6552C8.23874 14.7489 8.36588 14.8016 8.49846 14.8016C8.63104 14.8016 8.75819 14.7489 8.85193 14.6552C8.94568 14.5615 8.99834 14.4343 8.99834 14.3017V8.30315ZM11.4978 7.80327C11.3652 7.80327 11.238 7.85593 11.1443 7.94968C11.0505 8.04343 10.9979 8.17057 10.9979 8.30315V14.3017C10.9979 14.4343 11.0505 14.5615 11.1443 14.6552C11.238 14.7489 11.3652 14.8016 11.4978 14.8016C11.6303 14.8016 11.7575 14.7489 11.8512 14.6552C11.945 14.5615 11.9976 14.4343 11.9976 14.3017V8.30315C11.9976 8.17057 11.945 8.04343 11.8512 7.94968C11.7575 7.85593 11.6303 7.80327 11.4978 7.80327Z"
                fill="black"
              />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  const goalDietsCols = [
    {
      dataField: "day_no",
      text: "Day",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.day_no || "NA"}</span>;
      },
    },
    {
      dataField: "diet_time_name",
      text: "Diet Time",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.diet_time_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "meals",
      text: "Meals",
      formatter: (cell, row) => {
        // const meals = JSON.parse(row?.meal_id);
        // const mealsString = meals ? meals.join(", ") : "NA";
        return <span className="tb-data">{row?.meal_name || "NA"}</span>;
      },
    },
    {
      dataField: "quantities",
      text: "Quantities",
      formatter: (cell, row) => {
        // const quantities = JSON.parse(row?.quantity);
        // const quantitiesString = quantities ? quantities.join(", ") : "NA";
        return <span className="tb-data">{row?.quantity || 0}</span>;
      },
    },
    {
      dataField: "total_cal",
      text: "Total Calorie",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.total_cal || "0"}</span>;
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formattedLongDate(+row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27 bold"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <HelmetWrapper title="WTF: Diet Package">
      <>
        <>
          {/* <ReactModal
        onRequestClose={() => setIsAddModalOpen(false)}
        ariaHideApp={false}
        isOpen={isAddModalOpen}
      >
        <div className="modal-body-k bg-white small rounded-4">
          <ModalHeader
            title={"Add Unit"}
            onClick={() => setIsAddModalOpen(false)}
          />
          <Suspense fallback={<Loader />}>
            <DietPackageForm onClose={() => setIsAddModalOpen(false)} />
          </Suspense>
        </div>
      </ReactModal>

      <ReactModal
        onRequestClose={() => setIsEditModalOpen({ status: false, data: null })}
        ariaHideApp={false}
        isOpen={isEditModalOpen?.status}
      >
        <div className="modal-body-k bg-white small rounded-4">
          <ModalHeader
            title={"Edit Unit"}
            onClick={() => setIsEditModalOpen({ status: false, data: null })}
          />
          <Suspense fallback={<Loader />}>
            <DietPackageForm
              onClose={() => setIsEditModalOpen({ status: false, data: null })}
              data={isEditModalOpen?.data}
            />
          </Suspense>
        </div>
      </ReactModal> */}
        </>

        <Modal
          isOpen={clickValues.detailsModal}
          onRequestClose={() => {
            setClickValues((prevs) => ({
              ...prevs,
              detailsModal: false,
              mealDetails: [],
            }));
          }}
          contentLabel="Details Modal"
          ariaHideApp={false}
        >
          <div className="createNewCTOModalContainer paymentDetailsModalContainer">
            <ModalHeadAndClose
              title="Diet Details (View Only)"
              onClose={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  detailsModal: false,
                  mealDetails: [],
                }))
              }
            />

            <div className="fullWidthFlexCenter">
              <ViewGoalDiets rowData={clickValues.rowData} />
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={isModalOpen.editModal}
          onRequestClose={onClose}
          contentLabel="Diet Package Edit Form Modal"
          ariaHideApp={false}
        >
          <DPForm
            token={token}
            closeModal={onClose}
            name={"edit"}
            rowData={isModalOpen.editData}
            callFunction={() => {
              try {
                refetchDietPackages();
              } catch (error) {
                console.log(error);
              }
            }}
          />
        </Modal>

        <Container
          className="bg-cloud-k dietMealsParentContainer px-50px"
          fluid
        >
          <Row>
            <Col>
              <MealsStructure text={"Diet Package"} />
            </Col>
          </Row>
          <Row>
            <Col>
              <DPfilters
                token={token}
                filters={dpFilters}
                setFilters={setDPFilters}
                searchFilterApplied={searchFilterApplied}
                onClickSearch={onClickSearch}
                callFunction={() => {
                  try {
                    refetchDietPackages();
                  } catch (error) {
                    console.log(error);
                  }
                }}
                handleKeyPress={handleKeyPress}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              {isData() ? (
                <div className="flex-k js-center-k items-center-k h-50vh-k">
                  <Loader />
                </div>
              ) : (
                <div className="fullWidthFlexCenter overflowAuto separatedTable">
                  <PaymentLinkTable
                    tableData={dietPackages?.data}
                    tableColumns={dietPackageCols}
                    tablePagination={dietPackages?.pagination}
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                  />
                </div>
              )}
            </Col>
          </Row>
        </Container>

        <>
          {/* <section className="p-3 dietPackageContainer">
          <div>
            <header className="flex-k js-between-k items-center-k">
              <h3 className="bold-text dark-text fs-large-k m-0">
                Diet Packages
              </h3>
              <div className="flex-k gap-1-k">
                <button className="btn-k btn-primary-k">
                  Add Diet Package
                </button>
                <button className="btn-k btn-primary-k">
                  Add Diet Feature
                </button>
              </div>
            </header>
          </div>

          <div>
            {isData() ? (
              <div className="flex-k js-center-k items-center-k h-50vh-k">
                <Loader />
              </div>
            ) : (
              <div>
                <LightTable
                  columns={dietPackageCols}
                  data={dietPackages?.data || []}
                />
                <PaginationLight
                  isPage={isPage + 1}
                  onChangePage={setIsPage}
                  pagination={dietPackages?.pagination || []}
                />
              </div>
            )}
          </div>

          <ReactModal
            onRequestClose={() => setIsAddModalOpen(false)}
            ariaHideApp={false}
            isOpen={isAddModalOpen}
          >
            <div className="modal-body-k bg-white small rounded-4">
              <ModalHeader
                title={"Add Unit"}
                onClick={() => setIsAddModalOpen(false)}
              />
              <Suspense fallback={<Loader />}>
                <DietPackageForm onClose={() => setIsAddModalOpen(false)} />
              </Suspense>
            </div>
          </ReactModal>

          <ReactModal
            onRequestClose={() =>
              setIsEditModalOpen({ status: false, data: null })
            }
            ariaHideApp={false}
            isOpen={isEditModalOpen?.status}
          >
            <div className="modal-body-k bg-white small rounded-4">
              <ModalHeader
                title={"Edit Unit"}
                onClick={() =>
                  setIsEditModalOpen({ status: false, data: null })
                }
              />
              <Suspense fallback={<Loader />}>
                <DietPackageForm
                  onClose={() =>
                    setIsEditModalOpen({ status: false, data: null })
                  }
                  data={isEditModalOpen?.data}
                />
              </Suspense>
            </div>
          </ReactModal>

          <SmallModal
            isOpen={imageModal?.status}
            onClose={() => setImageModal({ status: false, data: null })}
            title={"Diet Package Image"}
            data={
              <div className="flex-k js-center-k items-center-k">
                {imageModal?.data ? (
                  <img
                    className="image-k small"
                    src={imageModal?.data}
                    alt="diet package"
                  />
                ) : (
                  <span className="fs-normal-k my-3-k">
                    No Image Available!
                  </span>
                )}
              </div>
            }
          />
        </section> */}
        </>
      </>
    </HelmetWrapper>
  );
};

export default DietPackage;
